/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import {
  Flex,
  FormControl,
  FormLabel,
  Checkbox,
  Heading,
} from "@chakra-ui/react";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import FormInput from "../../../components/forms/form-Input";
import {
  _CAMERA_TYPES,
  CATEGORY_LIST,
  FIXING_SIDE,
  LOADING_SIDE_LIST,
  LOCATION_TYPES,
  SITE_TYPE_LIST,
  STATUS_LIST,
  WEEK_DAYS,
} from "../constants";
import NumericInput from "../../../components/forms/react-hook-numeric-input";
import FormHookDatePicker from "../../../components/forms/form-hook-date-picker";
import ReactHookFormDropdown from "../../../components/forms/react-hook-dropdown";
import {
  useLookupCashCenterRoutes,
  useLookupCities,
  useLookupEmirates,
  useLookupRegions,
} from "../../../services/lookups-mutations";
import { useGetServicePointListPaginated } from "../../../services/service-points";
import { formatDate } from "date-fns";
import { Button, Textarea } from "@repo/ui";

export default function Information({
  onNextStep,
  isValid,
  cashCenters,
  customerList,
  makersList,
  machineList,
  countriesList,
  onMakerChange,
  modelsList,
  control,
  errors,
  watch,
  handleSubmit,
  setValue,
  reset,
  editing,
  getValues,
  onFetchSlaDefaults,
}) {
  const { mutate: getRegions, data: regionsListRes } = useLookupRegions();
  const { mutate: getEmirates, data: emiratesListRes } = useLookupEmirates();
  const { mutate: getCities, data: citiesListRes } = useLookupCities();
  const { mutate: getAreas } = useLookupCities();
  const [locations, setLocations] = useState([]);
  const generalFieldProps = { control, errors };
  const { setError } = generalFieldProps.control;
  const selectedCustomer = watch("customerId");
  const selectedCity = watch("city");

  const onCustomerChange = (value) => {
    const findCustomer = customerList.find((item) => item.customerId === value);

    setValue("customerName", findCustomer?.name || "");
  };

  const onBillingCustomerChange = (value) => {
    const findCustomer = customerList.find((item) => item.customerId === value);

    setValue("billingCustomerName", findCustomer?.name || "");
  };

  const { data: routesListRes } = useLookupCashCenterRoutes(
    watch("cashCenterId"),
  );
  const {
    mutate: getServicePointsList,
    data: servicePointsList,
    isSuccess: servicePointListAvailable,
    reset: resetLocationsList,
  } = useGetServicePointListPaginated();
  useEffect(() => {
    const countryName = watch("country");
    const country = countriesList?.find((elm) => elm.name === countryName);
    if (country) {
      const countryCode = country.code;
      getRegions(countryCode);
      getCities(countryCode);
      getEmirates(countryCode);
    }
  }, [watch("country")]);
  // Watch selected customer and city
  useEffect(() => {
    if (!selectedCustomer || !selectedCity) return;

    // Extract actual customerId
    const customerId =
      selectedCustomer?.id ||
      selectedCustomer?.value ||
      selectedCustomer?.customerId;

    // Extract actual city string
    const city = selectedCity?.text || selectedCity;

    if (!customerId || !city) return;

    if (!editing && onFetchSlaDefaults) {
      onFetchSlaDefaults(customerId, city);
    }
  }, [selectedCustomer, selectedCity]);

  useEffect(() => {
    getServicePointsList({
      pageNumber: 1,
      pageRowCount: 3000,
      searchCriteria: "",
      operationDate: formatDate(new Date(), "yyyy-MM-dd'T'00:00:00.000'Z'"),
      cashCenterId: "",
      customerId: "",
    });
    getAreas("UAE");
  }, []);
  useEffect(() => {
    if (servicePointListAvailable) {
      setLocations(servicePointsList.data.data);
      resetLocationsList();
    }
  }, [servicePointListAvailable]);

  const handleBarCodeBlur = (e) => {
    const trimmed = e.target.value.trim();
    const currentLocationId = getValues("locationId");

    const duplicate = locations.find(
      (location) =>
        location.barcode?.trim().toLowerCase() === trimmed.toLowerCase() &&
        location.locationId !== currentLocationId,
    );

    if (duplicate) {
      setError("barcode", {
        type: "manual",
        message: "This barcode already exists for another location.",
      });
      setValue("barcode", "");
    } else {
      setValue("barcode", trimmed, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  };

  const formValidationRules = {
    customerId: { required: "Please Select Customer" },
    billingCustomerId: { required: "Please Select Billing Customer" },
    cashCenterId: { required: "Please Select Cash Center" },
    locationId: { required: "Please Enter Location Id" },
    locationName: { required: "Please Enter Location Name" },
    locationCode: { required: "Please Enter Location Code" },
    category: { required: "Please Select Category" },
    locationType: { required: "Please Select Location Type" },
    status: { required: "Please Select Status" },
    siteType: { required: "Please Select Site Type" },
    barcode: {
      required: "Please Enter Barcode",
      pattern: { value: /^[0-9\s]+$/, message: "Only numbers are allowed" },
      maxLength: {
        value: 30,
        message: "Value exceeds maximum number of characters (30)",
      },
      minLength: {
        value: 10,
        message: "Value should contains minimum 10 digits",
      },
    },
    machineSerialNo: { required: "Please Enter Machine Serial No" },
    routeNo: { required: "Please select route" },
    country: { required: "Please select country" },
    city: { required: "Please select city" },
    emirate: { required: "Please select emirate" },
    state: { required: "Please select state" },
  };
  const onCountryChange = (e) => {
    setValue("country", e.value);
    setValue("state", "");
    setValue("city", "");
    setValue("emirate", "");
  };
  const onCashCenterChange = (value) => {
    const findCashCenter = cashCenters.find(
      (item) => item.cashCenterId === value,
    );
    setValue("routeNo", "");
    setValue("cashCenterName", findCashCenter?.name || "");
  };

  const handleBlur = (e) => {
    const trimmed = e.target.value.trim();
    setValue("locationId", trimmed, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const submitInfo = (data) => {
    const barcodeError = errors?.barcode?.message;

    if (barcodeError) {
      return;
    }

    onNextStep(data);
  };

  const onSiteTypeChange = (value) => {
    if (value === "CIT") {
      reset({
        ...getValues(),
        siteType: value,
        hasSecurityAlarm: false,
        alarmDetails: "",
        fixingSide: "",
        loadingSide: "",
        machineType: "",
        maker: "",
        model: "",
        lockSerialNo: "",
        machineSerialNo: "",
        numberOfCassettes: 0,
        lockInstallationDate: null,
      });
    }
  };
  return (
    <form onSubmit={handleSubmit(submitInfo)}>
      <Flex w="100%" justify="space-between" flexDirection="row">
        <Heading style={{ width: "100%" }}>Information</Heading>
        <Flex w="100%" justify="flex-end" flexDirection="row">
          <Flex
            w="100%"
            justify="flex-end"
            flexDirection="row"
            gap="16px"
            onClick={() => {}}
          >
            <Button
              type="submit"
              disabled={!isValid}
              onClick={() => {
                onNextStep();
                handleBarCodeBlur({ target: { value: getValues("barcode") } });
              }}
              variant="secondary"
            >
              Next
            </Button>
          </Flex>
        </Flex>
      </Flex>

      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        filterable
        label="Customer"
        name="customerId"
        data={
          customerList?.map((item) => ({
            value: item.customerId,
            label: item.name,
          })) || []
        }
        placeholder="Select Customer"
        rules={formValidationRules.customerId}
        onChange={onCustomerChange}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        filterable
        label="Billing Customer"
        name="billingCustomerId"
        data={
          customerList?.map((item) => ({
            value: item.customerId,
            label: item.name,
          })) || []
        }
        placeholder="Select Billing Customer"
        rules={formValidationRules.billingCustomerId}
        onChange={onBillingCustomerChange}
      />
      <FormInput
        {...generalFieldProps}
        label="Contract Code"
        name="contractCode"
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        filterable
        label="Cash Center"
        name="cashCenterId"
        id="cashCenterId"
        text="name"
        data={
          cashCenters.map((item) => ({
            value: item.cashCenterId,
            label: item.name,
          })) || []
        }
        placeholder="Select Cash Center"
        rules={formValidationRules.cashCenterId}
        onChange={onCashCenterChange}
      />
      <FormInput
        {...generalFieldProps}
        isRequired
        label="Location ID"
        name="locationId"
        rules={formValidationRules.locationId}
        onBlur={handleBlur}
      />
      <FormInput
        {...generalFieldProps}
        isRequired
        label="Location Name"
        name="locationName"
        rules={formValidationRules.locationName}
      />
      <FormInput
        {...generalFieldProps}
        isRequired
        label="Location Code"
        name="locationCode"
        rules={formValidationRules.locationCode}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        filterable
        label="Category"
        name="category"
        id="id"
        text="text"
        data={CATEGORY_LIST}
        placeholder="Select Category"
        rules={formValidationRules.category}
      />

      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        filterable
        label="Route"
        name="routeNo"
        data={
          routesListRes?.data.map((route) => ({
            value: route.routeNo,
            label: route.routeNo,
          })) || []
        }
        placeholder="Select Route"
        rules={formValidationRules.routeNo}
        disabled={!watch("cashCenterId")}
        info={watch("cashCenterId") ? "" : "Select Cash Center To Enable"}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        filterable
        label="Location Type"
        name="locationType"
        data={LOCATION_TYPES || []}
        placeholder="Select Location Type"
        rules={formValidationRules.locationType}
      />

      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        filterable
        label="Status"
        name="status"
        data={STATUS_LIST || []}
        placeholder="Select Status"
        rules={formValidationRules.status}
      />

      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        filterable
        label="Site Type"
        name="siteType"
        data={SITE_TYPE_LIST || []}
        placeholder="Select Status"
        rules={formValidationRules.siteType}
        onChange={onSiteTypeChange}
      />

      <FormInput
        {...generalFieldProps}
        isRequired
        label="Barcode"
        name="barcode"
        rules={formValidationRules.barcode}
        onBlur={handleBarCodeBlur}
      />
      <FormInput {...generalFieldProps} label="Site Limit" name="siteLimit" />
      <NumericInput
        {...generalFieldProps}
        label="Distance From Base"
        name="distanceFromBase"
      />
      <NumericInput
        {...generalFieldProps}
        label="Co-Located Group No"
        name="coLocatedGroupNo"
      />

      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        filterable
        label="Country"
        name="country"
        data={countriesList.map((country) => ({
          value: country.name,
          label: country.name,
        }))}
        placeholder="Select Country"
        dropdownProps={{ filterable: true }}
        onChange={onCountryChange}
        rules={formValidationRules.country}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        filterable
        disabled={!watch("country")}
        label="State"
        name="state"
        data={
          regionsListRes?.data.map((elm) => ({
            value: elm.name,
            label: elm.name,
          })) || []
        }
        placeholder="Select State"
        dropdownProps={{ filterable: true }}
        info={!watch("country") ? "Select country To Enable" : ""}
        rules={formValidationRules.state}
      />

      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        filterable
        disabled={!watch("country")}
        label="City"
        name="city"
        data={
          citiesListRes?.data.map((elm) => ({
            value: elm.name,
            label: elm.name,
          })) || []
        }
        placeholder="Select City"
        dropdownProps={{ filterable: true }}
        info={!watch("country") ? "Select country To Enable" : ""}
        rules={formValidationRules.city}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        filterable
        disabled={!watch("country")}
        label="Emirate"
        name="emirate"
        data={
          emiratesListRes?.data.map((elm) => ({
            value: elm.name,
            label: elm.name,
          })) || []
        }
        placeholder="Select Emirate"
        dropdownProps={{ filterable: true }}
        info={!watch("country") ? "Select country To Enable" : ""}
        rules={formValidationRules.emirate}
      />
      <FormInput {...generalFieldProps} label="Address" name="address" />
      <NumericInput {...generalFieldProps} label="Longitude" name="longitude" />
      <NumericInput {...generalFieldProps} label="Latitude" name="latitude" />

      <FormHookDatePicker
        {...generalFieldProps}
        datePickerProps={{ placeholder: "Select Service Date" }}
        label="First Service Date"
        name="firstServiceDate"
      />
      <FormHookDatePicker
        {...generalFieldProps}
        datePickerProps={{ placeholder: "Select Decommissioned Date" }}
        label="Decommissioned Date"
        name="decomissionedDate"
      />
      <FormControl>
        <FormLabel>Service Days</FormLabel>
        <Controller
          control={control}
          name="serviceDays"
          render={({ field }) => (
            <MultiSelect
              value={field.value}
              data={WEEK_DAYS}
              filterable={false}
              onChange={(e) => {
                field.onChange(e.target.value);
              }}
            />
          )}
        />
      </FormControl>
      <FormControl>
        <FormLabel>Allowed Days</FormLabel>
        <Controller
          control={control}
          name="allowedDays"
          render={({ field }) => (
            <MultiSelect
              value={field.value}
              data={WEEK_DAYS}
              filterable={false}
              onChange={(e) => {
                field.onChange(e.target.value);
              }}
            />
          )}
        />
      </FormControl>

      <NumericInput {...generalFieldProps} label="Bins" name="numberOfBins" />
      <NumericInput {...generalFieldProps} label="Keys" name="numberOfKeys" />
      <ReactHookFormDropdown
        {...generalFieldProps}
        label="Has Camera"
        name="hasCamera"
        placeholder="Select"
        data={[
          { label: "Yes", value: 1 },
          { label: "No", value: 0 },
        ]}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        label="Camera Type"
        name="cameraType"
        disabled={!watch("hasCamera")}
        placeholder="Select"
        data={_CAMERA_TYPES}
      />
      <FormHookDatePicker
        {...generalFieldProps}
        datePickerProps={{ placeholder: "Select Installation Date" }}
        label="Machine Installation Date"
        name="machineInstallationDate"
      />
      {/* <FormInput {...generalFieldProps} label="Area" name="area" /> */}

      <FormInput {...generalFieldProps} label="Area" name="area" />
      <FormInput
        {...generalFieldProps}
        label="Requested By"
        name="requestedBy"
      />
      <div style={{ width: "100%" }} />
      <FormControl>
        <Controller
          control={generalFieldProps.control}
          name="requiresCashierCount"
          render={({ field }) => {
            return (
              <Checkbox isChecked={field.value} onChange={field.onChange}>
                <FormLabel style={{ margin: 0 }}>
                  Requires Cashier Count
                </FormLabel>
              </Checkbox>
            );
          }}
        />
      </FormControl>
      <FormControl>
        <Controller
          control={generalFieldProps.control}
          name="requiresEVhr"
          render={({ field }) => {
            return (
              <Checkbox isChecked={field.value} onChange={field.onChange}>
                <FormLabel style={{ margin: 0 }}>Requires EVhr</FormLabel>
              </Checkbox>
            );
          }}
        />
      </FormControl>
      {watch("siteType") !== "CIT" ? (
        <>
          <FormControl>
            <Controller
              control={generalFieldProps.control}
              name="hasSecurityAlarm"
              render={({ field }) => {
                return (
                  <Checkbox isChecked={field.value} onChange={field.onChange}>
                    <FormLabel style={{ margin: 0 }}>
                      Has Security Alarm
                    </FormLabel>
                  </Checkbox>
                );
              }}
            />
          </FormControl>
          <div style={{ width: "100%" }} />
          <FormInput
            {...generalFieldProps}
            label="Alarm Details"
            name="alarmDetails"
            disabled={!watch("hasSecurityAlarm")}
          />
          <ReactHookFormDropdown
            {...generalFieldProps}
            filterable
            label="Fixing Side"
            name="fixingSide"
            id="id"
            text="text"
            data={FIXING_SIDE || []}
            placeholder="Select Fixing Side"
          />
          <ReactHookFormDropdown
            {...generalFieldProps}
            filterable
            label="Loading Side"
            name="loadingSide"
            id="id"
            text="text"
            data={LOADING_SIDE_LIST || []}
            placeholder="Select Loading Side"
          />

          <ReactHookFormDropdown
            {...generalFieldProps}
            filterable
            label="Machine Type"
            name="machineType"
            data={
              machineList?.map((item) => ({
                value: item.description,
                label: item.description,
              })) || []
            }
            placeholder="Select Machine Type"
          />

          <ReactHookFormDropdown
            {...generalFieldProps}
            filterable
            label="Maker"
            name="maker"
            data={
              makersList?.map((item) => ({
                value: item.name,
                label: item.name,
              })) || []
            }
            placeholder="Select Maker"
            onChange={onMakerChange}
          />
          <ReactHookFormDropdown
            {...generalFieldProps}
            filterable
            label="Model"
            name="model"
            id="name"
            text="name"
            data={
              modelsList?.map((item) => ({
                value: item.name,
                label: item.name,
              })) || []
            }
            placeholder="Select Model"
          />

          <FormInput
            {...generalFieldProps}
            label="Lock Serial No"
            name="lockSerialNo"
          />
          <FormInput
            {...generalFieldProps}
            label="Machine Serial No"
            name="machineSerialNo"
            isRequired={watch("siteType") !== "CIT"}
            rules={
              watch("siteType") === "CIT"
                ? {}
                : formValidationRules.machineSerialNo
            }
          />
          <NumericInput
            {...generalFieldProps}
            label="Number Of Cassettes"
            name="numberOfCassettes"
          />

          <FormHookDatePicker
            {...generalFieldProps}
            datePickerProps={{ placeholder: "Select Installation Date" }}
            label="Lock Installation Date"
            name="lockInstallationDate"
          />
        </>
      ) : (
        <></>
      )}

      <div style={{ width: "100%" }} />
      <FormControl>
        <Controller
          control={generalFieldProps.control}
          name="followStandardModels"
          render={({ field }) => {
            return (
              <Checkbox isChecked={field.value} onChange={field.onChange}>
                <FormLabel style={{ margin: 0 }}>
                  Follow Standard Models
                </FormLabel>
              </Checkbox>
            );
          }}
        />
      </FormControl>
      <FormControl>
        <Controller
          control={generalFieldProps.control}
          name="followStandardCassettes"
          render={({ field }) => {
            return (
              <Checkbox isChecked={field.value} onChange={field.onChange}>
                <FormLabel style={{ margin: 0 }}>
                  Follow Standard Cassettes
                </FormLabel>
              </Checkbox>
            );
          }}
        />
      </FormControl>
      <FormControl style={{ width: "40%" }}>
        <Controller
          control={generalFieldProps.control}
          name="followStandardDenominations"
          render={({ field }) => {
            return (
              <Checkbox isChecked={field.value} onChange={field.onChange}>
                <FormLabel style={{ margin: 0 }}>
                  Follow Standard Denominations
                </FormLabel>
              </Checkbox>
            );
          }}
        />
      </FormControl>
      <div className="full-width-field" style={{ gridColumn: "span 4" }}>
        <FormControl>
          <FormLabel>Comments</FormLabel>
          <Controller
            control={control}
            name="comments"
            render={({ field }) => (
              <Textarea
                value={field.value}
                onChange={(e) => field.onChange(e.target.value)}
              />
            )}
          />
        </FormControl>
      </div>
    </form>
  );
}
